if (!customElements.get('mvg-variant-picker')) {
  customElements.define('mvg-variant-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.mvgReady) return;
      this.mvgReady = true;

      this.card = this.closest('product-item');
      this.optionIndex = Number(this.dataset.optionIndex);
      this.moneyFormat = this.dataset.moneyFormat || '$';
      this.variantInput = this.querySelector('[data-mvg-variant-id]');
      this.addButton = this.querySelector('[data-mvg-add]');
      this.addLabel = this.querySelector('[data-mvg-add-label]');
      this.priceElement = this.card ? this.card.querySelector('[data-mvg-price]') : null;
      this.compareElement = this.card ? this.card.querySelector('[data-mvg-compare]') : null;

      try {
        this.variants = JSON.parse(this.querySelector('[data-mvg-variants]').textContent);
      } catch (error) {
        this.variants = [];
      }

      this.querySelectorAll('[data-mvg-option]').forEach((button) => {
        button.addEventListener('click', () => this.selectOption(button));
      });
    }

    selectOption(button) {
      const value = button.dataset.mvgOption;
      const currentId = Number(this.variantInput.value);
      const current = this.variants.find((variant) => variant.id === currentId);

      let match = this.variants.find((variant) => {
        if (!variant.available || variant.options[this.optionIndex] !== value) return false;
        if (!current) return true;

        return variant.options.every((option, index) => {
          return index === this.optionIndex || option === current.options[index];
        });
      });

      if (!match) {
        match = this.variants.find((variant) => {
          return variant.available && variant.options[this.optionIndex] === value;
        });
      }

      if (!match) return;

      this.querySelectorAll('[data-mvg-option]').forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', String(selected));
      });

      this.updateVariant(match);
    }

    updateVariant(variant) {
      this.variantInput.value = variant.id;

      if (this.priceElement) {
        this.priceElement.textContent = this.formatMoney(variant.price);
        this.priceElement.classList.toggle('price--highlight', Boolean(variant.compare_at_price && variant.compare_at_price > variant.price));
      }

      if (this.compareElement) {
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.compareElement.hidden = !onSale;
        this.compareElement.textContent = onSale ? this.formatMoney(variant.compare_at_price) : '';
      }

      this.addButton.disabled = !variant.available;
      this.addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';

      if (this.card && variant.featured_image && variant.featured_image.src) {
        const primaryImage = this.card.querySelector('.product-item__primary-image:not([hidden])');
        if (primaryImage) {
          primaryImage.src = variant.featured_image.src;
          primaryImage.removeAttribute('srcset');
        }
      }
    }

    formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, this.moneyFormat);
      }

      const amount = Number(cents || 0) / 100;
      const fixed = amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
      const rounded = Math.round(amount).toLocaleString();

      return this.moneyFormat
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, rounded)
        .replace(/\{\{\s*amount\s*\}\}/, fixed);
    }
  });
}
